import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getReminderStore = (state: RootState) => state.reminderStore;
const getRemindersList = createSelector(getReminderStore, ({ remindersList = [] }) => remindersList);

export { getRemindersList };
